export default __webpack_public_path__ + "static/media/superballs.6f9cd4c0.png";